import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const LAST_ACTIVE_KEY = "app_last_active";
const INACTIVITY_MS = 10 * 60 * 1000; // 10 minutes
const ACTIVITY_EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "scroll",
  "touchstart",
];

export function useSessionGuard() {
  const navigate = useNavigate();
  const inactivityTimer = useRef(null);

  const logout = (reason) => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("name");
    localStorage.removeItem("app_active_tab");
    localStorage.removeItem(LAST_ACTIVE_KEY);
    localStorage.setItem("logout_reason", reason);
    navigate("/admin", { replace: true });
  };

  const resetTimer = () => {
    localStorage.setItem(LAST_ACTIVE_KEY, Date.now().toString());
    clearTimeout(inactivityTimer.current);
    inactivityTimer.current = setTimeout(
      () => logout("inactivity"),
      INACTIVITY_MS,
    );
  };

  // ── inactivity timeout — only runs when logged in ───────────────────────────
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return; // not logged in, skip entirely

    const lastActive = Number(
      localStorage.getItem(LAST_ACTIVE_KEY) || Date.now(),
    );
    if (Date.now() - lastActive > INACTIVITY_MS) {
      logout("inactivity");
      return;
    }

    resetTimer();
    ACTIVITY_EVENTS.forEach((evt) =>
      window.addEventListener(evt, resetTimer, { passive: true }),
    );

    return () => {
      clearTimeout(inactivityTimer.current);
      ACTIVITY_EVENTS.forEach((evt) =>
        window.removeEventListener(evt, resetTimer),
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ── sync logout across tabs ─────────────────────────────────────────────────
  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === "token" && !e.newValue) {
        navigate("/admin", { replace: true });
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [navigate]);
}
